import React, { type ChangeEvent } from 'react';
import { Checkbox } from '@atlaskit/checkbox';
import { CheckboxField } from '@atlaskit/form';
import type { Props } from './types.tsx';
import { setRetainValue } from './utils.tsx';

const CheckboxGroupEdit = (props: Props): React.JSX.Element => {
	const { values, options, isDisabled = false, onChange, isInvalid, fieldId } = props;

	const onChangeCheckedItems = (event: ChangeEvent<HTMLInputElement>) => {
		const itemValue = event.target.value;
		const retainValue = setRetainValue({ options, itemValue, values });
		onChange(retainValue);
	};

	return (
		<>
			{options?.map((option) => (
				<CheckboxField name={fieldId} key={option.value}>
					{({ fieldProps }) => (
						<Checkbox
							{...fieldProps}
							key={option.value}
							value={option.value}
							label={option.label}
							isChecked={values?.some((data) => data.value === option.value)}
							onChange={onChangeCheckedItems}
							isInvalid={isInvalid}
							isDisabled={isDisabled}
						/>
					)}
				</CheckboxField>
			))}
		</>
	);
};

export default CheckboxGroupEdit;
